import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule ,FormsModule} from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { ResetPasswordComponent } from './reset-password.component';
import { ServicesSharedModule } from 'src/app/services/services-shared.module';
import { ResetPasswordVerifyFirstStepComponent } from './reset-password-verify-first-step/reset-password-verify-first-step.component';
import { ResetPasswordVerifySecondStepComponent } from './reset-password-verify-second-step/reset-password-verify-second-step.component';
import { ResetPasswordVerifyThirdStepComponent } from './reset-password-verify-third-step/reset-password-verify-third-step.component';
import { ResetPasswordMFAComponent } from './reset-password-mfa/reset-password-mfa.component';
import { ResetPasswordMFASecondStepComponent } from './reset-password-mfa-second-step/reset-password-mfa-second-step.component';
import { ResetPasswordMFAEmailComponent } from './reset-password-mfa-email/reset-password-mfa-email.component';
import { ResetPassword2FAComponent } from './reset-password-2-fa/reset-password-2-fa.component';
import { ResetPasswordMfaAuthAppComponent } from './reset-password-mfa-auth-app/reset-password-mfa-auth-app.component';


@NgModule({
  declarations: [
    ResetPasswordComponent,
    ResetPasswordVerifyFirstStepComponent,
    ResetPasswordVerifySecondStepComponent,
    ResetPasswordVerifyThirdStepComponent,
    ResetPasswordMFAComponent,
    ResetPassword2FAComponent,
    ResetPasswordMfaAuthAppComponent,
    ResetPasswordMFASecondStepComponent,
    ResetPasswordMFAEmailComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    ServicesSharedModule
  ]
})
export class ResetPasswordModule {}